import { useContext, useEffect, useState, useRef } from "react"
import { AppContext } from "../App"
import { AiOutlineUser } from 'react-icons/ai';
import { callApi, formatMoney, getInlineLoader } from "../Helpers";
import {
	STR_INDIVIDUALS,
	STR_GROUPS,
	STR_CREATE_NEW_CONTACT,
	STR_INVALID_NAME,
	STR_INVALID_PHONE,
	STR_INVALID_WHATSAPP_NUMBER,
	STR_SUCCESS,
	STR_NAME,
	STR_PHONE_NUMBER,
	STR_WHATSAPP_NUMBER,
	STR_OPTIONAL,
	STR_SUBMIT,
	STR_NO_RECORD,
	STR_EXCEL_FILE_HELPER_TEXT_GROUP,
	STR_INVALID_FILE,
	STR_FILE,
	STR_DELETE_GROUP_WARNING,
	STR_DOWNLOAD_CONTACT_WARNING
} from "../Strings";
import { BsFillPersonLinesFill, BsPersonGear } from 'react-icons/bs';
import { MdDelete, MdDownloading, MdInfoOutline, MdMessage, MdMoney, MdOutlineMoneyOff, MdOutlinePayment, MdOutlinePayments, MdOutlinePhonelinkSetup, MdPeople, MdWhatsapp } from 'react-icons/md';
import { GiPayMoney } from "react-icons/gi";
import { TbMoneybag } from "react-icons/tb";
import { LiaMoneyCheckSolid } from "react-icons/lia";
import { GrMoney } from "react-icons/gr";
import OneContact from '../ones/OneContact';

export default function View({ id }) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [loading, setLoading] = useState(false);
	const [data, setData] = useState(null);
	

	async function init() {
		//run initializations here
		setReady(false);
		await getData();
		setReady(true);
	}

	
	async function uploadContactsSheet() {
		let contactsSheet = null;

		try {
			contactsSheet = document.getElementById('_contactsSheet').files[0];
		} catch (error) {
			
		}

		if(contactsSheet) {
			setLoading(true);
			await callApi('upload-contacts-sheet-to-group', { contactsSheet, groupId: id, }).then(response => {
				if(response.status === 1) {
					appContext.tellMessage(STR_SUCCESS[appContext.language]);
					getData();
					
				} else {
					appContext.tellError(response.msg);
				}
			})
			setLoading(false);
		} else {
			appContext.tellError(STR_INVALID_FILE[appContext.language]);
		}
	}

	async function getData() {
		await callApi(
			"get-contact-group-data",
			{
				id,
			}
		).then((response) => {
			if(response.status === 1) {
				setData(response.data)
			} 
		})
	}

	async function deleteGroup() {
		setLoading(true);
		await callApi(
			"delete-group",
			{
				id,
			}
		).then((response) => {
			if(response.status === 1) {
				appContext.tellMessage(STR_SUCCESS[appContext.language]);
				appContext.navBack();
				appContext.getAllContacts();
				appContext.getAllContactGroups();
			} else {
				appContext.tellError(response.msg);
			}
		})
		setLoading(false);
	}
async function downloadGroup() {
    setLoading(true);

	try {

    /*Call API directly so we have the response object*/
    const response = await callApi("get-contact-group-data", { id });

    /* Check if API returned valid data */
    if (response.status !== 1 || !response.data) {
      appContext.tellError(response.msg );
      return;
    }

    const groupData = response.data;

    /* Check if group has contacts*/
    if (!groupData.contacts || groupData.contacts.length === 0) {
      appContext.tellError("No contacts available in this group for download.");
      return;
    }

    /* Prepare CSV content*/
    const headers = ["Name", "Phone Number", "WhatsApp Number"];
    let csvRows = [headers.join(",")];

    /* Loop through contacts to add rows*/
    groupData.contacts.forEach(contact => {
      const row = [
        contact.name,
        `="${contact.phoneNumber}"`, 
        contact.whatsAppNumber ? `="${contact.whatsAppNumber}"` : "N/A"
      ];
      csvRows.push(row.join(","));
    });

    const csvContent = csvRows.join("\n");

    /* Create CSV Blob for download*/
    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = URL.createObjectURL(blob);

    /* Trigger download*/
    const link = document.createElement("a");
    link.href = url;
    link.download = `${groupData.name.replace(/\s+/g, "_")}_Contacts.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

	appContext.tellMessage(STR_SUCCESS[appContext.language]);
  } catch (error) {
   
  } 
    setLoading(false);
  
}







	useEffect(() => {
		init();
	}, [])


	useEffect(() => {
		appContext.setShowOverlayLoader(loading);
	}, [ loading ])

	if (ready) {
		return (
			<div
				className="container"
			>
			
				<div className="row">

					<div className="col-md-12">
						<h6
							className="font-semi-bold"
							style={{
								fontSize: "32px"
							}}
						>
							{data.name}
						</h6>

						<div className="mt-4">
						
							<h6
								style={{
									fontSize: "14px"
								}}
							>
								{data.description}
							</h6>
						</div>

						{
							(Number(appContext.currentUserData.defaultAllContactsGroupId) !== Number(id)) ?
							<div className="mt-4 text-end">
								<button
									className="btn btn-danger"
									onClick={() => {
										appContext.activateDialog({
											message: STR_DELETE_GROUP_WARNING[appContext.language],
											onConfirm: deleteGroup,
										})
									}}
								>
									<MdDelete size={24}/>
								</button>
									<button
									className="btn btn-success ms-2"
									onClick={() => {
										appContext.activateDialog({
											message: STR_DOWNLOAD_CONTACT_WARNING[appContext.language],
											onConfirm: downloadGroup,
										})
									}}
								>
									<MdDownloading size={24}/>
								</button>
								
							</div>
							:""
						}

						<hr/>

					</div>

					<div className="col-md-12">
						<div className="mb-3 mt-3">
							<h6
								style={{
									fontSize: "18px"
								}}
							>
								{STR_EXCEL_FILE_HELPER_TEXT_GROUP[appContext.language]}
							</h6>
						</div>

						<div className="mb-3 mt-3">
							<label className="form-label">{STR_FILE[appContext.language]}</label>
							<input
								type="file"
								className="form-control"
								accept=".xls,.xlsx"
								id="_contactsSheet"
							/>
						</div>

						<div className="mb-3 mt-3 text-end">
							<button
								className="btn btn-rounded bg-secondary btn-padded"
								onClick={uploadContactsSheet}
							>
								{STR_SUBMIT[appContext.language]}
							</button>
						



						</div>

					</div>

					<div className="col-md-12">
						<h6
							style={{
								fontSize: "24px"
							}}
							className="font-semi-bold text-muted"
						>
							<MdPeople/> {data.contacts?.length || 0}
						</h6>
						{
							(data.contacts && data.contacts.length > 0) ?
							data.contacts.map((item, i) => {
								return (
									<OneContact data={item} key={i}/>
								)
							})
							:
							<h6
								style={{
									fontSize: "14px"
								}}
							>
								{STR_NO_RECORD[appContext.language]}
							</h6>
						}
					</div>
					
				</div>
			</div>
		)
	} else {
		return (
			<div
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}


}